import { Box, Text } from '@mantine/core';

type StatusDisplayProps = {
  error?: unknown | null;
  isEmptyData?: boolean;
};

export const StatusDisplay = ({ error, isEmptyData }: StatusDisplayProps) => {
  if (!error && !isEmptyData) return null;

  const message = error ? 'Data loading error' : isEmptyData ? 'No data to display' : '';

  return (
    <Box
      style={{
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Text size="lg">{message}</Text>
    </Box>
  );
};
